<template>
  <MainComponents v-if="!isShowCalibration" />

  <div class="app_new_page new_background-main" v-if="isShowCalibration">
    <calibration />
  </div>

  <div class="app_new_page new_background-main" v-if="magnetSetKeyGroup.state.isShowSetKeyGroup">
    <mgx_set_group />
  </div>

  <div class="app_new_page new_background-main" v-if="isShowNotConnect">
    <device_not_connect />
  </div>

  <div class="app_new_page new_background-main" v-if="isShowSleep">
    <device_sleep />
  </div>

  <div class="app_new_page new_background-main" v-if="isShowTester">
    <tester />
  </div>

  <mgx_introduce></mgx_introduce>
  <qmk_btn />
</template>

<script lang="ts" setup>
import { speciaBehiver, specialCheck } from '@/define/limit'
import { appConfig } from '@/model/config'
import { DeviceManager } from '@/service/device'
import { calibrationHandler } from '@/service/driver/calibration_set'
import { magnetSetKeyGroup } from '@/service/driver/magnet_key_group'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import Calibration_button from '../calibration/calibration_button.vue'
import Calibration from '../calibration/calibration.vue'
import Mgx_set_group from '../mgx_set/mgx_set_group.vue'
import Device_sleep from '../device_sleep/device_sleep.vue'
import Tester, { isShowTester } from '../tester/tester.vue'

import Mgx_introduce from '../mgx_set/mgx_introduce.vue'
import Qmk_btn from '../qmk/qmk_btn.vue'
import MainComponents from './main.vue'
import { resetAppState } from '@/service/app_lifecycle'
import firmware from '@/upgrade/firmware'
import Device_not_connect from '../device_not_connect/device_not_connect.vue'
import { DevicePid } from '@/define/define'

const isShowNotConnect = ref(false)

const checkFe87V2ConnectionStatus = async () => {
  if ([DevicePid.IrokFe87V2_24g, DevicePid.IrokFe87V2IMC_24g].includes(DeviceManager.instance.state.currentPid) == false) {
    return
  }
  try {
    await firmware.getFirmwareVersion()
  } catch (error) {
    isShowNotConnect.value = true
  }
}
onMounted(() => {
  appConfig.isShowLeft = true
  checkFe87V2ConnectionStatus()
})

onUnmounted(() => {
  console.log('current device unmounted')
  resetAppState()
})

const isShowSleep = computed(() => {
  return DeviceManager.instance.state.deviceStatus.IsSleep == true && specialCheck(speciaBehiver.SupportSleep, DeviceManager.instance.state.currentPid)
})

const isShowCalibration = computed(() => calibrationHandler.state.isShowHidCalibration || calibrationHandler.state.isShowCalibrationSelect || calibrationHandler.state.isShowExeSingleCalibration || calibrationHandler.state.isShowExeAllCalibration)
</script>

<style lang="less" scoped>
.app_new_page {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  display: none;
  z-index: 1;
  padding-top: 60px;
  display: flex;
  justify-content: center;
}
</style>
